import { DemoAccountsPicker } from "@/components/demo-accounts/demo-accounts-picker";
import { devOverridesEnabled } from "@/lib/hooks/admin/use-dev-overrides";
import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * One-click login for demo accounts (dev/staging only).
 */
export const Route = createFileRoute("/_auth/demo-accounts")({
  beforeLoad: () => {
    if (!devOverridesEnabled) {
      throw redirect({ to: "/login" });
    }
  },
  component: DemoAccountsPicker,
});
